import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWheniworkComponent } from './simple-icons-wheniwork.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWheniworkComponent ],
    exports:      [ SimpleIconsWheniworkComponent ],
    bootstrap:    []
})
export class SimpleIconsWheniworkModule {}
